var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertCloseBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LegacyIcon/Cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.9378 5.55943C18.2063 5.82791 18.2288 6.24925 18.0052 6.54327L17.938 6.62009L12.8123 11.7476L17.941 16.8763C18.2339 17.1692 18.2339 17.644 17.941 17.9369C17.6725 18.2054 17.2511 18.2278 16.9571 18.0041L16.8803 17.9369L11.7516 12.8082L6.62716 17.9356C6.33432 18.2285 5.85939 18.2287 5.5665 17.9358C5.29801 17.6673 5.2755 17.246 5.49918 16.9519L5.56628 16.8751L10.6909 11.7476L5.56513 6.62176C5.27224 6.32886 5.27224 5.85399 5.56513 5.5611C5.83361 5.29261 6.25501 5.27024 6.54899 5.49397L6.62579 5.5611L11.7516 10.6869L16.8772 5.55964C17.17 5.26669 17.6449 5.26653 17.9378 5.55943Z",
    fill: "#1761C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertCloseBlue);
export default __webpack_public_path__ + "static/media/icon-alert-close-blue.fd1cc41b38872ca9222167b98a59e6d9.svg";
export { ForwardRef as ReactComponent };